import dashboardApi from '@/api/dashboard'

export default {
  namespaced: true,
  
  state: {
    statistics: null,
    warningList: [],
    weeklyOutbound: []
  },
  
  mutations: {
    SET_STATISTICS(state, data) {
      state.statistics = data
    },
    SET_WARNING_LIST(state, list) {
      state.warningList = list
    },
    SET_WEEKLY_OUTBOUND(state, data) {
      state.weeklyOutbound = data
    }
  },
  
  actions: {
    // 获取仪表盘数据
    async fetchDashboardData({ commit }) {
      try {
        const [statistics, warningList, weeklyOutbound] = await Promise.all([
          dashboardApi.getStatistics(),
          dashboardApi.getWarningList(),
          dashboardApi.getWeeklyOutbound()
        ])
        
        commit('SET_STATISTICS', statistics)
        commit('SET_WARNING_LIST', warningList)
        commit('SET_WEEKLY_OUTBOUND', weeklyOutbound)
      } catch (error) {
        console.error('Failed to fetch dashboard data:', error)
      }
    }
  },
  
  getters: {
    statistics: state => state.statistics || {},
    warningList: state => state.warningList,
    weeklyOutbound: state => state.weeklyOutbound
  }
} 